export default __webpack_public_path__ + "static/media/backgroundplans.87623bf0.png";